<template>
  <div class="page_custEmp">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
        <div class="flex aic">
          <el-form :inline="true" :model="listQuery" class="re_down_form" label-width="88px">
            <el-form-item label="归属项目" size="small">
              <el-select v-model="listQuery.projectId" size="small" filterable clearable placeholder="" style="width: 140px;">
                <el-option v-for="(item, index) in projectList" :key="index" :label="item.StrprojectName" :value="item.Projectid">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="开票时间" size="small">
              <div class="flex">
                <el-date-picker v-model="listQuery.begin" type="date" value-format="yyyy-MM-dd" size="small" style="width:140px">
                </el-date-picker>
                <div style="margin: 0 5px;"> ~ </div>
                <el-date-picker v-model="listQuery.end" type="date" value-format="yyyy-MM-dd" size="small" style="width:140px">
                </el-date-picker>
              </div>
            </el-form-item>
            <el-button v-preventReClick type="success" size="small" @click="searchHandle" style="margin-left: 15px;">搜索</el-button>
          </el-form>
        </div>
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>发票</el-breadcrumb-item>
        </el-breadcrumb>
      </div>

      <div class="ftabs">
        <el-table :data="tableData" border class="doc_table" v-loading="loading" style="width:100%" @selection-change="handleSelectionChange">
          <el-table-column label="开票抬头" key="1" prop="strLegalsubName" min-width="140" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column label="对方公司" prop="custName" key="2" min-width="140" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column label="项目" prop="strprojectName" key="2.1" min-width="140" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column label="开票金额" key="3" prop="amount" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column label="税额" key="4" prop="rantAmount" min-width="160" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column label="开票方式" key="5" prop="billingMethod" min-width="120" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column label="票种" key="6" prop="typeInvoice" min-width="100" :show-overflow-tooltip="true" align="center">
            <template slot-scope={row}>{{ row.ticketType + row.type }}</template>
          </el-table-column>
          <el-table-column label="发票号码" key="7" prop="invoiceNumber" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column label="开票内容" key="8" prop="content" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column label="状态" key="9" prop="status" min-width="140" :show-overflow-tooltip="true" align="center">
          </el-table-column>

          <el-table-column label="操作" min-width="100" align="center" fixed="right">
            <template slot-scope={row}>
              <div class="injuryTabBtn">
                <el-button type="text" size="small" @click="downRowInvoice(row)">下载发票</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="block">
          <el-pagination v-if="totalCount>0" @current-change="currentChange" :current-page.sync="listQuery.page" :page-size="Number(listQuery.pageSize)" @size-change="handleSizeChange" :page-sizes="[10,20, 50, 100, 200]" layout="total,sizes,prev,pager, next, jumper" :total="totalCount"></el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import moment from 'moment';
  import xz from "../../common";
  import checkPermission from '@/utils/permission' // 权限判断函数
  import {
    e
  } from 'mathjs';
  export default {
    data() {
      return {
        listQuery: {
          page: 1,
          pageSize: 10,
          orders: [],
          userId: Cookies.get("userid-b"),
          roleType: localStorage.loginRoletype,
          projectId: null,
          beginTime: "",
          endTime: ""
        },
        isBtnLoading: false,
        projectList: [], //项目列表
        showDropScreen: -1,
        tableData: [],
        roletype: localStorage.loginRoletype,
        totalCount: 0,
        loading: false,
      }
    },
    created() {
      this.getProList();
      this.getList();
    },
    methods: {
      checkPermission,
      //获取项目
      getProList() {
        let data = {
          projectname: "", // 项目名称
          projectid: "", // 项目id
          custname: "", //客户名称
          strAchieveowner: "", // 业绩归属人
          strservuserid: "", // 客服
          strBusiStat: "", //项目状态
          strpartner2: "", //合伙人
          perpage: 100000000,
          currpage: 1,
          strorgancode: "",
          roletype: this.roletype,
        }
        xz.getProjectLists(data).then((res) => {
          if (res.status == "ok") {
            this.projectList = res.msg;
          } else {
            this.projectList = [];
          }
        });
      },
      currentChange(val) {
        this.listQuery.page = Number(val);
        this.getList();
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.listQuery.page = 1;
        this.listQuery.pageSize = val;
        this.getList();
      },
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      searchHandle() {
        this.listQuery.currpage = 1;
        this.getList();
      },
      getList() {
        this.loading = true;
        xz.ReportFun(this.listQuery, 'GetBillPageList').then(res => {
          if (res.status == 'ok') {
            this.tableData = res.data.data;
            this.loading = false;
            this.totalCount = res.data.totalCount
          } else {
            this.tableData = [];
            this.loading = false;
            this.totalCount = 0;
          }
        })
      },
      //筛选下拉
      dropDownScreen() {
        if (this.showDropScreen == -1) {
          this.showDropScreen = 1;
        } else if (this.showDropScreen == 1) {
          this.showDropScreen = -1;
        }
      },
      changeTab() {
        this.getList();
      },
      downRowInvoice(row) {
        let data = {
          id: [row.id],
          type: 2,
          wjlx: 'PDF',
          isforce: false,
          ismerge: false
        }
        xz.IvoiceFun(data, 'DownLoadInviceFile/download').then(res => {
          if (res.status == 'ok') {
            this.isDowning = false;
            if (res.data.length > 0) {
              res.data.forEach(element => {
                let url = this.$store.state.EMP.imgPath + element;
                window.open(url, '_blank');
              });
            }
          }
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .ftabs {
    background: #fff;
    padding: 10px 16px 16px;
    margin-bottom: 16px;
  }

  .ftabBtn {
    padding: 10px 0;
  }

  .r_dropDownScreen {
    width: 100%;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background-color: #fff;
  }

  .re_down_form .el-form-item {
    margin-bottom: 3px;
    margin-right: 0;
  }

  .scr_icon.i_txt {
    display: inline-block;
    font-size: 12px;
    cursor: pointer;
  }
</style>
<style>
  .page_custEmp .eleTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_custEmp .doc_table .el-table__body td.el-table__cell {
    padding: 5px 0;
  }

  .page_custEmp .doc_table .el-table__body th.el-table__cell {
    padding: 8px 0;
  }

  .page_custEmp .el-input__icon {
    height: 32px;
    line-height: 32px;
  }

  .page_custEmp .el-input-group__append,
  .el-input-group__prepend {
    padding: 0 10px;
    background: #fff;
  }

  .page_custEmp .injuryTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_custEmp .checkedgroup .el-checkbox {
    margin-right: 10px;
  }

  .page_custEmp .el-checkbox__label {
    padding-left: 3px;
  }

  .page_custEmp .checkedgroup2 .el-checkbox {
    margin-bottom: 5px;
  }

  .dia_label_box .el-checkbox.is-bordered+.el-checkbox.is-bordered {
    margin-left: 0;
  }

  .dia_label_box .el-checkbox.is-bordered.is-checked,
  .dia_label_box .el-checkbox__input.is-focus .el-checkbox__inner {
    border-color: #19BD92;
  }

  .dia_label_box .el-checkbox {
    border: 1px solid #ddd;
    padding: 2px 3px;
    border-radius: 3px;
    height: auto;
    margin: 5px 20px 0 0;
  }

  .p_resource_module .r_dropDownScreen .el-checkbox__label,
  .dia_label_box .el-checkbox__label {
    padding-left: 3px;
  }
</style>